var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymbolshape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 14",
    d: "M12.1796 3.46952C13.0216 2.13563 13.4426 1.46868 13.9943 1.26777C14.3739 1.12949 14.7901 1.12949 15.1698 1.26777C15.7215 1.46868 16.1425 2.13563 16.9845 3.46952C17.9322 4.97093 18.4061 5.72163 18.3226 6.34106C18.2654 6.76592 18.0516 7.15405 17.7231 7.42935C17.2443 7.83073 16.3568 7.83073 14.582 7.83073C12.8072 7.83073 11.9198 7.83073 11.4409 7.42935C11.1125 7.15405 10.8987 6.76592 10.8414 6.34106C10.758 5.72163 11.2318 4.97093 12.1796 3.46952Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1900",
    d: "M1.66602 4.4974C1.66602 3.10861 1.66602 2.41421 2.01969 1.92742C2.13391 1.77021 2.27216 1.63196 2.42938 1.51773C2.91616 1.16406 3.61056 1.16406 4.99935 1.16406C6.38814 1.16406 7.08253 1.16406 7.56932 1.51773C7.72653 1.63196 7.86479 1.77021 7.97901 1.92742C8.33268 2.41421 8.33268 3.10861 8.33268 4.4974C8.33268 5.88619 8.33268 6.58058 7.97901 7.06737C7.86479 7.22458 7.72653 7.36284 7.56932 7.47706C7.08253 7.83073 6.38814 7.83073 4.99935 7.83073C3.61056 7.83073 2.91616 7.83073 2.42938 7.47706C2.27216 7.36284 2.13391 7.22458 2.01969 7.06737C1.66602 6.58058 1.66602 5.88619 1.66602 4.4974Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1585",
    cx: 14.5833,
    cy: 14.4974,
    rx: 3.33333,
    ry: 3.33333,
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.91532 11.5781L2.08203 17.4115M2.08208 11.5781L7.91536 17.4115",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolshape);
export default __webpack_public_path__ + "static/media/symbolshape.e347282ef1453b8281944f1d20518948.svg";
export { ForwardRef as ReactComponent };